import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var PhoneCall = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor"
  };
  return React.createElement(StyledIconBase, tslib_1.__assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    fill: "none",
    d: "M16.585 19.999l2.006-2.005-2.586-2.586-1.293 1.293a.991.991 0 0 1-.912.271c-.115-.024-2.842-.611-4.502-2.271s-2.247-4.387-2.271-4.502a.999.999 0 0 1 .271-.912l1.293-1.293-2.586-2.586L4 7.413c.02 1.223.346 5.508 3.712 8.874 3.355 3.356 7.625 3.691 8.873 3.712z",
    key: "k0"
  }), React.createElement("path", {
    d: "M16.566 21.999h.028c.528 0 1.027-.208 1.405-.586l2.712-2.712a.999.999 0 0 0 0-1.414l-4-4a.999.999 0 0 0-1.414 0l-1.594 1.594c-.739-.22-2.118-.72-2.992-1.594s-1.374-2.253-1.594-2.992l1.594-1.594a.999.999 0 0 0 0-1.414l-4-4a1.03 1.03 0 0 0-1.414 0L2.586 5.999c-.38.38-.594.902-.586 1.435.023 1.424.4 6.37 4.298 10.268s8.844 4.274 10.268 4.297zM6.005 5.408l2.586 2.586-1.293 1.293a.996.996 0 0 0-.271.912c.024.115.611 2.842 2.271 4.502s4.387 2.247 4.502 2.271a.994.994 0 0 0 .912-.271l1.293-1.293 2.586 2.586-2.006 2.005c-1.248-.021-5.518-.356-8.873-3.712C4.346 12.921 4.02 8.636 4 7.413l2.005-2.005zm13.994 5.591h2c0-5.13-3.873-8.999-9.01-8.999v2c4.062 0 7.01 2.943 7.01 6.999z",
    key: "k1"
  }), React.createElement("path", {
    d: "M12.999 8c2.103 0 3 .897 3 3h2c0-3.225-1.775-5-5-5v2z",
    key: "k2"
  }));
});
PhoneCall.displayName = 'PhoneCall';
export var PhoneCallDimensions = {
  height: 24,
  width: 24
};